// src/redux/reducers/heroUserReducer.js

// Define the initial state for the hero user
const initialState = {
  uid: null,
  email: null,
  name: null,
  company: null,
  collectionBrand: null,
  userGroup: null,
  userRole: null,
  // User group details
  userGroupDetails: {},
  userGroupPermissions: [],
  userGroupSettings: {},
};

// The heroUserReducer handles SET_HERO_USER and CLEAR_HERO_USER actions
const heroUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_HERO_USER":
      return {
        ...state,
        uid: action.payload.uid,
        email: action.payload.email,
        name: action.payload.name,
        company: action.payload.company,
        collectionBrand: action.payload.collectionBrand,
        userGroup: action.payload.userGroup,
        userRole: action.payload.userRole,
        // User group details
        userGroupDetails: action.payload.userGroupDetails || {},
        userGroupPermissions: action.payload.userGroupPermissions || [],
        userGroupSettings: action.payload.userGroupSettings || {},
      };
    case "CLEAR_HERO_USER":
      return initialState;
    default:
      return state;
  }
};

export default heroUserReducer;
